import React from "react";

class RadioField extends React.Component{
    render(){
        const that = this

        const value_type = typeof this.props.value

        return (
            <div class="js-form-field-switch-wrapper 1">
                <input
                    type="radio"
                    name={this.props.name}
                    id={this.props.id}
                    value={this.props.value}
                    required={this.props.required}
                    data-initial-type={value_type}
                    />

                <div class="js-switch">
                    <div class="js-switch__track">
                        <div class="js-switch__thumb"></div>
                    </div>
                </div>

                <label for={this.props.id} class="form__label">
                    {this.props.label}
                    {this.props.required && (
                        <span class="chart-red">*</span>
                    )}
                </label>
            </div>
        )
    }
}

export default RadioField